import * as yup from 'yup';

export const validations = yup.object().shape({
  description: yup.string().required('A descrição é obrigatória'),
  amount: yup.string().required('O valor é obrigatório')
});